import React from 'react';
import { useTranslation } from 'react-i18next';
import { CardView, InfoRowView } from '@sentara-health/optimahealth_web';

interface SummaryCardData {
  labelKey: string;
  value: string;
  isHighlighted: boolean;
  variant: string;
}

interface SuperEOBSummaryCardsProps {
  totalCharges: string;
  totalPaidByPlan: string;
  patientResponsibility: string;
  className?: string;
}

const SuperEOBSummaryCards: React.FC<SuperEOBSummaryCardsProps> = ({
  totalCharges,
  totalPaidByPlan,
  patientResponsibility,
  className = '',
}) => {
  const { t } = useTranslation();

  const cardsData: SummaryCardData[] = [
    {
      labelKey: 'medicalClaims.totalCostOfCare',
      value: `$${Number(totalCharges) === 0 ? 0 : totalCharges}`,
      isHighlighted: false,
      variant: 'tertiary'
    },
    {
      labelKey: t('medicalClaims.employerCovered').toUpperCase(),
      value: `$${Number(totalPaidByPlan) === 0 ? 0 : totalPaidByPlan}`,
      isHighlighted: false,
      variant: 'tertiary'
    },
    {
      labelKey: 'medicalClaims.youMayOwe',
      value: `$${Number(patientResponsibility) === 0 ? 0 : patientResponsibility}`,
      isHighlighted: true,
      variant: 'primary'
    },
  ];

  return (
<div className={`row row-cols-1 row-cols-md-3 g-3 mb-5 ${className}`}>
  {cardsData.map((card) => (
    <div key={card.labelKey} className="col d-flex">
      <CardView
        radius="md"
        border="primary"
        className={'text-center border p-4 shadow-none flex-fill d-flex flex-column justify-content-center'}
        variant={card.variant}
      >
        <InfoRowView
          label={card.labelKey === 'medicalClaims.totalCostOfCare' ? t(card.labelKey).toUpperCase() : t(card.labelKey)}
          sublabel={card.value}
          layout="stacked"
          sublabelAs="headings"
          sublabelVariant="extrabold"
          labelColor="disable"
          labelVariant="bold"
          sublabelColor={card.isHighlighted ? 'secondary' : 'primary'}
        />
      </CardView>
    </div>
  ))}
</div> 
  );
};

export default SuperEOBSummaryCards;